<script setup>
import { ref, watch } from 'vue';
import KanbanColumn from 'dashboard/components-next/Contacts/Kanban/KanbanColumn.vue';

const props = defineProps({
  // [{ value, label, contacts, meta, isFetching, isFetchingMore }]
  columns: { type: Array, required: true },
});

const emit = defineEmits(['loadMore', 'moveCard', 'cardClick']);

const localColumns = ref([]);

watch(
  () => props.columns,
  newColumns => {
    localColumns.value = newColumns.map(column => ({
      value: column.value,
      contacts: column.contacts.map(contact => ({
        ...contact,
        kanbanSourceColumnValue: column.value,
      })),
    }));
  },
  { immediate: true, deep: true }
);

const handleChange = (columnValue, event) => {
  if (!event.added) return;

  const { element } = event.added;
  const fromColumnValue = element.kanbanSourceColumnValue;
  if (fromColumnValue === columnValue) return;

  emit('moveCard', {
    contactId: element.id,
    fromColumnValue,
    toColumnValue: columnValue,
  });
};
</script>

<template>
  <div class="flex items-start w-full h-full gap-4 overflow-x-auto">
    <KanbanColumn
      v-for="(column, index) in columns"
      :key="column.value"
      :column-label="column.label"
      :contacts="localColumns[index]?.contacts || []"
      :meta="column.meta"
      :is-fetching="column.isFetching"
      :is-fetching-more="column.isFetchingMore"
      @change="event => handleChange(column.value, event)"
      @load-more="emit('loadMore', column.value)"
      @card-click="id => emit('cardClick', id)"
    />
  </div>
</template>
